export default __webpack_public_path__ + "static/media/poi-id-back.ff7e02e7.png";